import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject, Observable} from 'rxjs';
import {MenuItem} from 'primeng/api';

@Injectable()
export class AppBreadcrumbService {
  public searchInputVisible: boolean = false;
  public filtersVisible: boolean = false;
  public query: string = '';
  private itemsSource = new BehaviorSubject<MenuItem[]>([]);
  private searchQuery: Subject<string> = new Subject<string>();
  public searchSubscriber =  this.searchQuery.asObservable();
  private filtersClicked: Subject<void> = new Subject<void>();
  public filtersClickedSubscriber: Observable<void> = this.filtersClicked.asObservable();


  itemsHandler = this.itemsSource.asObservable();

  public get currentItems(): MenuItem[] {
    return this.itemsSource.value;
  }

  setItems(items: MenuItem[]) {
    this.itemsSource.next(items);
  }

  emitQuery(query: string) {
    this.searchQuery.next(query);
  }

  emitFiltersClicked(): void {
    this.filtersClicked.next();
  }
}
